import React from "react";

import { Container, Segment, Header, Icon, Button } from "semantic-ui-react";
import { withRouter } from "react-router-dom";

import { connect } from "react-redux";

import { isOwner } from "../../../util/capability";

const SetupView = props => {
  return (
    <Container text style={{ marginTop: "3em" }}>
      <Segment color="blue" padded>
        <Header as="h2">
          <Icon name="lock" />
          <Header.Content>
            Connect your bank to Spout
            <Header.Subheader>
              Connecting your bank is fast and secure.
            </Header.Subheader>
          </Header.Content>
        </Header>
        <div style={{ fontSize: "1.1em" }}>
          <p>
            Connect {props.organization}'s bank account to use Transactions.
          </p>
          {isOwner() && (
            <div
              style={{
                textAlign: "center",
                marginBottom: "2em",
                marginTop: "2em"
              }}
            >
              <Button
                basic
                primary
                onClick={() => props.history.push("/settings/banks")}
                icon
                labelPosition="left"
              >
                <Icon name="lock" />View Bank Settings
              </Button>
            </div>
          )}
          {!isOwner() && (
            <div
              style={{
                textAlign: "center",
                marginBottom: "1em",
                marginTop: "2em"
              }}
            >
              <Button basic disabled primary icon labelPosition="left">
                <Icon name="lock" /> View Bank Settings
              </Button>
              <br />
              You must be an owner connect a bank.
            </div>
          )}

          <p>
            Spout uses{" "}
            <a
              href="https://plaid.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Plaid
            </a>{" "}
            to securely interact with your bank account. Plaid handles all
            interactions with your bank - Spout never sees your username or
            password, and can only access your transaction data through Plaid's
            servers.
          </p>
        </div>
      </Segment>
    </Container>
  );
};

const mapStateToProps = state => ({
  organization: state.user.organization.name
});

export default withRouter(connect(mapStateToProps)(SetupView));



// WEBPACK FOOTER //
// ./frontend/src/views/pages/transactions/SetupView.js